export default __webpack_public_path__ + "static/media/Inter-Medium.be3029dd.woff2";